import { memo, useMemo } from 'react';
import styled from '@emotion/styled';

import { Item, ItemDescription } from './BusinessItem';
import { H3 } from './HeadlineItem';

import type { Wws_EmbedItem } from '../../types/graphql';

const Iframe = styled("div")`
  display: flex;
  justify-content: center;

  div {
    width: 100%;
  }
`;

export interface EmbedItemProps {
  item: Wws_EmbedItem;
  className?: string | undefined;
}

function EmbedItem({ item, className }: EmbedItemProps) {
  const { id, title, description, embededCode } = item;

  const dangerouslySetInnerHTML = useMemo<{
    __html: string;
  }>(
    () => ({
      __html: embededCode,
    }),
    [embededCode]
  );

  return (
    <Item className={className} data-testid={`embed-item-${id}`}>
      {title ? <H3>{title}</H3> : null}

      {description ? <ItemDescription>{description}</ItemDescription> : null}

      <Iframe dangerouslySetInnerHTML={dangerouslySetInnerHTML} />
    </Item>
  );
}

export default memo(EmbedItem);
